import React from 'react';
import { Formatters } from "../../../../../attribute/index.js";
export function GenericCustomTextAttributeRenderer(props) {
  const {
    value,
    model
  } = props;
  const v = Formatters.format(value, model.formatter);
  return typeof v === 'string' ? v : Array.isArray(v) ? v.join(' ') : null;
}
export default {
  id: 'Rich.Text.Editor.CustomTextAttributeRenderer.Generic',
  valueType: '*',
  Component: GenericCustomTextAttributeRenderer
};